import { PERMISSIONS } from '../../constants'
import list from './PendingPointsList'

export default {
  list,
  name: 'chains/chainId/pending-points',
  permissions: [PERMISSIONS.PENDING_POINTS]
}